import { FC } from 'react';
import { AboutContent } from './AboutContent';
import style from './CoatingAboutStyle.module.css';
import { CustomBgPageTemplate } from '@/components/uiParts/Template/CustomBgPageTemplate/CustomBgPageTemplate';

type CoatingAboutPageProps = {
  showLink?: boolean;
};

export const CoatingAboutPage: FC<CoatingAboutPageProps> = ({
  showLink = true,
}) => {
  return (
    <CustomBgPageTemplate
      pageName="CoatingAbout"
      title="ボディコーティング"
      background={{ background: '#fff' }}
      showNavBack
    >
      <div className={style['full-page']}>
        <AboutContent showLink={showLink} />
      </div>
    </CustomBgPageTemplate>
  );
};
